/*================================================================================== */
/* Jquery START ==================================================================== */

function resizeTestimonials() {
	var prevTesti = 0;
	$('.testimonial-item').css('min-height', '');
	$('.testimonial-item').each(function () {
		if ($(this).outerHeight() > prevTesti) {
			prevTesti = $(this).outerHeight();
		}
	})
	$('.testimonial-item').css('min-height', prevTesti);
}

// Set unique values for the array "ar"
function uniqueArray(ar) {
	var j = {};

	ar.forEach(function (v) {
		j[v + '::' + typeof v] = v;
	});

	return Object.keys(j).map(function (v) {
		return j[v];
	});
}

// Equalize blocks height by setting the same min-height value
function equalizeBlocks() {
	var blockArray = $('[data-eq]').map(function () {
		return $(this).data('eq');
	}).get();
	var blocks = uniqueArray(blockArray);

	blocks.forEach(function (elem) {
		var prev = 0;
		$('[data-eq="' + elem + '"]')
			.css('height', '')
			.each(function () {
				if ($(this).outerHeight() > prev) {
					prev = $(this).outerHeight();
				}
			})
			.css('height', prev + 'px');
	});

	var blockArray2 = $('[data-eq-min-master]').map(function () {
		return $(this).data('eq-min-master');
	}).get();
	var blocks2 = uniqueArray(blockArray2);

	blocks2.forEach(function (elem) {
		$('[data-eq-min-target="' + elem + '"]').css('max-height', ($('[data-eq-min-master="' + elem + '"]').outerHeight() - 200) + 'px');
	});
}

function squareBlocks() {
	$('[data-square]').css('min-height', '');
	$('[data-square]').each(function (ev) {
		$(this).css('min-height', $(this).outerWidth());
	});
}

function equalizeTimeline() {
	var ph = 0;
	var phbot = 0;
	var slideTop = $('.timeline-slider__slide--top');
	var slideBot = $('.timeline-slider__slide--bottom');
	var slide = $('.timeline-slider__slide');
	var bgBlock = $('.timeline-slider__background');

	// Reset bg block
	bgBlock.css({
		'height': '',
		'top': ''
	});

	// Equalize heights
	equalizeBlocks();

	// Reset margins
	slide.css('margin-top', '');

	// Get bigger image
	slide.each(function () {
		if ($(this).hasClass('timeline-slider__slide--top')) {
			ph = $(this).find('.timeline-slider__image').outerHeight() > ph ? $(this).find('.timeline-slider__image').outerHeight() : ph;
		}
		else {
			phbot = $(this).find('.timeline-slider__image').outerHeight() > phbot ? $(this).find('.timeline-slider__image').outerHeight() : phbot;
		}
	});

	// Images on top
	slideTop.each(function () {
		// Get bigger image
		var finalHeight = ph - $(this).find('.timeline-slider__image').outerHeight();
		var bgHeight = $(this).find('.timeline-slider__image').outerHeight() / 2;

		$(this).css('margin-top', finalHeight + 'px');
		$(this).find('.timeline-slider__background').css('height', bgHeight + 'px');
	});

	// Images on bottom
	slideBot.each(function () {
		var bgHeight = $(this).find('.timeline-slider__image').outerHeight() / 2;
		$(this).css('margin-top', ph + 'px');
		$(this).find('.timeline-slider__background').css({
			'height': bgHeight + 'px',
			'top': - bgHeight + 'px'
		})
	});
}

function timelineSlideToggle(slide) {
	var slidesNb = $('.timeline-slider__slide:not(.slick-cloned)').length;
	var index = slide.data('slick-index');
	var maxHeight = 100;
	var slideClone = false;

	if (slide.hasClass('timeline-slider__slide--active')) {
		$('.timeline-slider__slide').removeClass('timeline-slider__slide--active');
		$('.timeline-slider__content-right').hide();
		$('.timeline-slider').slick('setPosition');
	}
	else {
		// Reset all slides
		$('.timeline-slider__slide').removeClass('timeline-slider__slide--active');
		$('.timeline-slider__content-right').hide();

		// Go to selected slide
		/*$('.timeline-slider').slick('slickGoTo', parseInt(index), false);*/

		// If we toggle a cloned slide, toggle for original slide too
		if (index != $('.timeline-slider').slick('slickCurrentSlide')) {
			slideClone = $('.timeline-slider__slide[data-slick-index="' + $('.timeline-slider').slick('slickCurrentSlide') + '"]');
		}

		// If we toggle an original slide, toggle for cloned slide too
		if (index < slidesNb) {
			slideClone = $('.timeline-slider__slide[data-slick-index="' + (slidesNb - 1 + index) + '"]');
		}

		if (slideClone !== false) {
			slideClone.addClass('timeline-slider__slide--active');
			slideClone.find('.timeline-slider__content-right').fadeIn();
			maxHeight = 310 - slideClone.find('.timeline-slider__content-right-head').outerHeight();
			slideClone.find('.timeline-slider__text').css('max-height', maxHeight + 'px');
			slideClone.find('.timeline-slider__text').mCustomScrollbar();
		}

		// Toggle slide content
		slide.addClass('timeline-slider__slide--active');

		// Reveal text panel
		slide.find('.timeline-slider__content-right').show();
		// Calculate max-height of the text
		// maxHeight = card height (390) - paddings (40-40) - heading
		maxHeight = 310 - slide.find('.timeline-slider__content-right-head').outerHeight();
		if (maxHeight < slide.find('.timeline-slider__text').outerHeight()) {
			slide.find('.timeline-slider__text').css('max-height', maxHeight + 'px');
			slide.find('.timeline-slider__text').mCustomScrollbar();
		}
	}
}

jQuery(document).ready(function ($) {
	"use strict";

	tarteaucitron.user.gtagUa = 'UA-13222478-6';
	tarteaucitron.user.gtagMore = function () { /* add here your optionnal gtag() */ };
	(tarteaucitron.job = tarteaucitron.job || []).push('gtag');

	tarteaucitron.init({
		"privacyUrl": "", /* Privacy policy url */

		"hashtag": "#tarteaucitron", /* Open the panel with this hashtag */
		"cookieName": "tarteaucitron", /* Cookie name */

		"orientation": "bottom", /* Banner position (top - bottom) */

		"showAlertSmall": false, /* Show the small banner on bottom right */
		"cookieslist": false, /* Show the cookie list */

		"closePopup": false, /* Show a close X on the banner */

		"showIcon": false, /* Show cookie icon to manage cookies */
		"iconPosition": "BottomRight", /* BottomRight, BottomLeft, TopRight and TopLeft */

		"adblocker": false, /* Show a Warning if an adblocker is detected */

		"DenyAllCta": true, /* Show the deny all button */
		"AcceptAllCta": true, /* Show the accept all button when highPrivacy on */
		"highPrivacy": true, /* HIGHLY RECOMMANDED Disable auto consent */

		"handleBrowserDNTRequest": false, /* If Do Not Track == 1, disallow all */

		"removeCredit": false, /* Remove credit link */
		"moreInfoLink": true, /* Show more info link */

		"useExternalCss": false, /* If false, the tarteaucitron.css file will be loaded */
		"useExternalJs": false, /* If false, the tarteaucitron.js file will be loaded */

		//"cookieDomain": ".my-multisite-domaine.fr", /* Shared cookie for multisite */

		"readmoreLink": "", /* Change the default readmore link */

		"mandatory": true, /* Show a message about mandatory cookies */
	});

	// Slider Homepage
	$('.home-slider').flexslider({
		selector: '.home-slider__slides > li',
		customDirectionNav: $(this).find('.home-slider__nav a'),
		controlNav: false,
		pauseOnHover: true,
		slideshow: true,
		slideshowSpeed: 3500,
	});
	$(".play-video-services").on("click", function (ev) {
		let $parent = $(this).parents(".video-player");
		let $thumbnail = $parent.find(".video-thumbnail");
		let $btn = $parent.find(".section__btn");
		let $video = $parent.find(".video");

		$btn.hide();
		$thumbnail.hide();
		$parent.removeClass('black-opacity');
		var video = $video.attr("src");
		// console.log(video);
		if (video.includes("?start=")) {
			$video.attr("src", `${video}&rel=0&mute=1&autoplay=1`);
		} else {
			$video.attr("src", `${video}?rel=0&mute=1&autoplay=1`);
		}
		ev.preventDefault();
	});

	$('.home-slider__nav a').on('click', function (e) {
		$('.home-slider').flexslider('play');
	});

	$('.toggle-slide-play-video').click(function (e) {
		e.preventDefault();
		var ytId = $(this).data('yt-id');

		if (ytId) {
			$('.home-slider').flexslider('pause');
			var ytPlayer = '<iframe width="100%" height="500" src="https://www.youtube.com/embed/' + ytId + '?rel=0&amp;controls=1&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1" frameborder="0" allowfullscreen class="video-embed"></iframe>';
			$(this).hide();
			$(this).after(ytPlayer);
		}

	});

	// Block Values switch
	$('.block-values__list .values-item').click(function (e) {
		var index = $(this).index();

		$('.block-values__desc').hide();
		$('.block-values__list .values-item').removeClass('values-item--active')
		$(this).addClass('values-item--active');
		$('#block-values-' + index).fadeIn(250);
	});

	$('.toggle-langs-bar').on('click', function(e) {
		$('.select-languages').toggleClass('select-languages--active');
	});

	// Slider Values responsive (mobile)
	function getGridSizeValues() {
		return (window.innerWidth < 767) ? 1 :
			(window.innerWidth < 990) ? 4 : 5;
	}

	if ($(window).width() < 992) {

		$('.block-values__list-container > .container').flexslider({
			selector: '.block-values__list > .values-item',
			animation: "slide",
			itemWidth: 200,
			minItems: getGridSizeValues(),
			maxItems: getGridSizeValues(),
			customDirectionNav: $('.block-values__nav a'),
			controlNav: false,
			slideshow: false,
			after: function (slider) {

				if ($(window).width() < 768) {
					$('.block-values__desc').hide();
					$('.block-values__list .values-item').removeClass('values-item--active')
					$('.block-values__list .values-item:eq(' + slider.currentSlide + ')').addClass('values-item--active');
					$('#block-values-' + slider.currentSlide).fadeIn(250);
				}
			}
		});
		// store the slider in a local variable
		var $window = $(window),
			flexsliderValues = { vars: {} };
		// tiny helper function to add breakpoints

		// check grid size on resize event
		$window.resize(function () {
			var gridSize = getGridSizeValues();

			flexsliderValues.vars.minItems = gridSize;
			flexsliderValues.vars.maxItems = gridSize;
		});
	}

	// Integrated Group Pantone
	$('.group-pantone__item').click(function () {
		var item = $(this),
			title = item.data('poi-title'),
			img = item.data('poi-img'),
			desc = item.data('poi-desc'),
			link = item.data('poi-link'),
			contentEl = $('.block-integratedgroup__item-details');

		if (title && img && desc) {
			$(contentEl).fadeOut(100, function () {
				$('.pantone-item__img').prop({ 'src': img, 'alt': title });
				$('.pantone-item__title').html(title);
				$('.pantone-item__text').html(desc);
				$('.group-pantone__item').removeClass('group-pantone__item--active');
				item.addClass('group-pantone__item--active');
				$(contentEl).fadeIn(100);

				$('html, body').animate({
					scrollTop: $('.block-integratedgroup__pantone').offset().top + $('.block-integratedgroup__pantone').outerHeight() - 70
				}, 750);
			});
		}
	});

	// Slider Keyfigures
	var flexsliderKeyFigures;

	$('.block-keyfigures__list').each(function () {

		$(this).flexslider({
			selector: '.keyfigures-list__slides .keyfigures-list__item',
			animation: "slide",
			customDirectionNav: $(this).find('.keyfigures-list__nav a'),
			controlNav: false,
			slideshow: false
		});
	});

	// Block cards grid item details
	$('.card-grid__item').click(function () {
		var item = $(this),
			contentEl = $('.block-cards__item-details'),
			bottomBlocks = $('.bottom-blocks'),
			key = $(this).data('key');

		$(contentEl).hide();
		$(bottomBlocks).hide();
		$('.card-grid__item').removeClass('card-grid__item--active');
		item.addClass('card-grid__item--active');
		$('.block-cards__item-details[data-key="'+ key + '"]').fadeIn(100);
		$('.bottom-blocks[data-key="'+ key + '"]').fadeIn(100);

		if ($(window).width() < 768) {
			$('html, body').animate({
				scrollTop: $('.block-cards__grid').offset().top + $('.block-cards__grid').outerHeight() - 70
			}, 750);
		}
	});

	/*
		 * Mosaique toggle
		 */
	$('.toggle-mosaique').on('click', function (e) {
		e.preventDefault();
		$('.mosaique__bloc--hidden').addClass('animated');
		// If blocks are displayed, add exit classes
		if ($(this).hasClass('active')) {
			$('.mosaique__bloc--hidden').removeClass('fadeInUp').addClass('fadeOutDown').delay(1000).fadeOut();
		}
		else {
			$('.mosaique__bloc--hidden').css('display', '').addClass('fadeInUp').removeClass('fadeOutDown');
		}

		$(this).toggleClass('active');
	});
	$('.block-jobs').on('click', '.mosaique__bloc--visible', function (e) {
		e.preventDefault();
		$(this).toggleClass('active');
	});
	// Enable animation
	$('[data-aos]').addClass('aos-init');
	AOS.init();

	// Counter(s) for keyvalues
	if ($('.keyfigures-list__slides').length > 0) {

		var kCounterInit = 0;
		$(window).scroll(function () {
			var oTop = $('.keyfigures-list__slides').offset().top - window.innerHeight;

			if (kCounterInit == 0 && $(window).scrollTop() > oTop) {
				$('.keyfigures-list__item strong').each(function () {
					var $this = $(this),
						countTo = $this.attr('data-count');

					if (jQuery.isNumeric(countTo)) {
						$({
							countNum: 0
						}).animate({
							countNum: countTo
						},
							{
								duration: 2500,
								easing: 'swing',
								step: function () {
									$this.text(Math.floor(this.countNum));
								},
								complete: function () {
									$this.text(this.countNum);
								}
							});
					}
				});
				kCounterInit = 1;
			}
		});
	}

	// Slider Universe brands
	/*$('.block-universe__brands-list').each(function() {
console.log("TEST2");		$(this).flexslider({
			selector: '.brands-list__slides > .brands-list__item',
			animation: "slide",
			itemWidth: 200,
			minItems: 3,
			maxItems: 3,
			customDirectionNav: $(this).find('.brands-list__nav a'),
			controlNav: false,
			slideshow: false
		});
	});*/


	// filter brand by category
	$(".filter").click(function () {
		if ($(this).hasClass('selected')) {
			$(".filter").removeClass('selected');
			$('.brands-list__item').show();
		} else {
			$(".filter").removeClass('selected');
			$(this).addClass('selected');
			let category = $(this).data('filter');

			if (category === 'all') {
				$('.brands-list__item').show();
			}
			else {
				$('.brands-list__item').hide();
				$('.brands-list__item[data-category="' + category + '"]').show();
				$('.brands-list__item').each(function () {
					var categories = $(this).attr('data-category');
					var catTable = $.map(categories.split(','), function (value) {
						return parseInt(value, 10);
					});

					if ($.inArray(category, catTable) !== -1) {
						$(this).fadeIn();
					}
				})
			}
		}
	});


	// Universe anchor animation
	$('.pw-universe-item__link').click(function (e) {
		e.preventDefault();
		var $currentItem = $('.block-universe__item:visible'),
			$itemTargeted = $('.block-universe__item' + this.hash),
			background = $(this).data('background');

		if (!$($itemTargeted).is(':visible')) {

			if ($currentItem.length > 0) {
				$currentItem.fadeOut(250, function () {
					$($itemTargeted).fadeIn(250, function () {
						// Reload sliders
						/*$('.block-keyfigures__item').each(function() {
							$(this).data('flexslider').setup();
						});
						$('.block-universe__brands-list').each(function() {
							$(this).data('flexslider').setup();
						});*/
					});
				});
			}
			else {
				$($itemTargeted).fadeIn(250, function () {
					// Reload sliders
					/*$('.block-keyfigures__list').each(function() {
						$(this).data('flexslider').setup();
					});
					$('.block-universe__brands-list').each(function() {
						$(this).data('flexslider').setup();
					});*/
				});
			}
		}

		$('html, body').animate({
			scrollTop: $('.block-universe').offset().top - 70
		}, 750);
	})

	// Manual Slider of universe items
	$('.block-universe__nav a').click(function (e) {
		e.preventDefault();

		var $currentItem = $(this).parents('.block-universe__item'),
			currentItemIndex = $currentItem.index(),
			totalItems = $('.block-universe__item').length,
			itemIndexToShow;

		if ($(this).hasClass('block-universe__nav-prev')) {
			itemIndexToShow = (currentItemIndex - 1 < 0) ? totalItems - 1 : currentItemIndex - 1;
		}
		else {
			itemIndexToShow = (currentItemIndex + 1 > totalItems - 1) ? '0' : currentItemIndex + 1;
		}

		$currentItem.fadeOut(250, function () {
			$('.block-universe__item:eq(' + itemIndexToShow + ')').fadeIn(250, function () {
				// Reload sliders
				$('.block-keyfigures__list').each(function () {
					$(this).data('flexslider').setup();
				})
				$('.block-universe__brands-list').each(function () {
					$(this).data('flexslider').setup();
				})
			});
		});
	});

	var str = window.location.href;
	if (str.indexOf("#press") != -1) {
		$("#global").removeClass("in active");
		$("#global_tab").removeClass("active");
		$("#press").addClass("in active");
		$("#press_tab").addClass("active");
	}

	// Testimonials
	$('.testimonials-slider').slick({
		dots: true,
		infinite: false,
		speed: 300,
		slidesToShow: 2,
		slidesToScroll: 2,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					autoplay: false,
					autoplaySpeed: 6000
				}
			}
		]
	});

	$(window).resize(function () {
		resizeTestimonials();
	});

	if ($(window).width() > 768) {
		$('.timeline-slider__content').hover(function (e) {
				e.preventDefault();
				timelineSlideToggle($(this).parents('.timeline-slider__slide'));
			});
		$('.timeline-slider__content-right').hover(function (e) {
			e.preventDefault();
			timelineSlideToggle($(this).parents('.timeline-slider__slide'));
		});
	} else {
		$('.timeline-slider__content-text').on('click', function (e) {
				e.preventDefault();
				timelineSlideToggle($(this).parents('.timeline-slider__slide'));
			});
	}

	// Hover effect on news blocks (big version)
	$(".block-news__item--big").each(function () {
		var height = $(this).outerHeight();

		height -= $(this).find(".news-item-content__title").outerHeight();
		height -= $(this).find(".news-item-content__date").outerHeight();
		height -= 75;

		$(this).find(".news-item-content").css("top", height - 40 + "px");
	})

	// Hover effect on news blocks (small version)
	$(".block-news__item--small").each(function () {
		var height = $(this).outerHeight();

		height -= $(this).find(".news-item-content__title").outerHeight();
		height -= $(this).find(".news-item-content__date").outerHeight();
		height -= 35;

		$(this).find(".news-item-content").css("top", height + "px");
	})
});

// INFINITE SCROLL

/* Set posts_per_page in display_listing_participation to activate load on scroll */
let ScrollDebounce = true;

$(window).scroll(function () {

	if ($('.press_listing_ajax').length) {

		/*console.log("lenght");*/

		if ($(window).scrollTop() >= $(".press_listing_ajax").offset().top) {

			/*console.log("dans la div");*/
			let currentPage = parseInt($(".press_listing_ajax").attr("data-current-page"));
			let nextPage = parseInt($(".press_listing_ajax").attr("data-next-page"));
			let maxPage = parseInt($(".press_listing_ajax").attr("data-max-page"));
			console.log(currentPage, nextPage, maxPage);
			if (maxPage >= nextPage) {
				$.ajax({
					'url': ajaxurl.url,
					'type': 'GET',
					async: false,
					'data': '&action=get_more_press_action&paged=' + nextPage,
					success: function (response) {
						let res = JSON.parse(response);
						$('.press_listing_ajax').append(res);
						$(".press_listing_ajax").attr("data-current-page", currentPage + 1);
						$(".press_listing_ajax").attr("data-next-page", nextPage + 1);
						equalizeBlocks();
					}
				});

			} else {
				console.log(currentPage, nextPage, maxPage);
			}
		}
	}
});
/* End Infinite Scroll */

$(window).on('load', function () {
	resizeTestimonials();

	$('.timeline-slider')
		.on('init', function (event, slick) {
			$(this).css({
				'opacity': 1,
				'visibility': 'visible'
			});
		})
		.on('beforeChange', function () {
			var w = window,
				d = document,
				e = d.documentElement,
				g = d.getElementsByTagName('body')[0],
				x = w.innerWidth || e.clientWidth || g.clientWidth;

			if (x < 768) {
				$('.timeline-slider__slide').removeClass('timeline-slider__slide--active');
				$('.timeline-slider__content-right').hide();
			}
		})
		.slick({
			infinite: true,
			slidesToShow: 7,
			slidesToScroll: 1,
			variableWidth: true,
			swipe: false,
			draggable: false,
			outerEdgeLimit: false,
			responsive: [
				{
					breakpoint: 991,
					settings: {
						infinite: false,
						slidesToScroll: 1,
						swipe: true,
						outerEdgeLimit: true,
						draggable: true
					}
				},
				{
					breakpoint: 767,
					settings: {
						infinite: false,
						slidesToScroll: 1,
						slidesToShow: 1,
						swipe: true,
						outerEdgeLimit: true,
						draggable: true,
						variableWidth: false
					},
				}
			]
		});

	$('.block-pictos-slider').slick({
		dots: true,
		arrows: true,
		autoplay: true,
		slidesToShow: 4,
		slidesToScroll: 4,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			}
		]
	});

	$('.block-ref-slider').slick({
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		variableWidth: false,
		//centerMode: true,
		swipe: true,
		draggable: true,
		prevArrow: $('#block-ref-slider__nav--prev'),
		nextArrow: $('#block-ref-slider__nav--next'),
		responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					variableWidth: false,
					autoplay: true,
				}
			}
		]
	}).on('afterChange', function (slick, currentSlide) {
		$('.block-ref-slider .slick-current a').tab('show');
		squareBlocks();
	});

	$('.block-ref-slider__slide').on('click', function (e) {
		e.preventDefault();
		slideIndex = $(this).data('slick-index');
		$('.block-ref-slider').slick('slickGoTo', parseInt(slideIndex), false);
	})

	$('.block-marques-slider').slick({
		infinite: true,
		slidesToShow: 2,
		slidesToScroll: 1,
		variableWidth: false,
		//centerMode: true,
		swipe: true,
		draggable: true,
		prevArrow: $('#block-marques-slider__nav--prev'),
		nextArrow: $('#block-marques-slider__nav--next'),
		responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					variableWidth: false,
					autoplay: true,
				}
			}
		]
	});

	$('.block-keyvisual-slider').slick({
		arrows: false,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 4000,
		swipe: true,
		draggable: true,
		dots: true,
		cssEase: 'linear'
	});

	$('.block-heroslider').slick({
		arrows: false,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 4000,
		swipe: true,
		draggable: true,
		dots: true,
		cssEase: 'linear'
	});

	// Services video block
	$(".play-video-services").on("click", function (ev) {
		let $parent = $(this).parents(".video-player");
		let $thumbnail = $parent.find(".video-thumbnail");
		let $btn = $parent.find(".section__btn");
		let $video = $parent.find(".video");

		$btn.hide();
		$thumbnail.hide();
		var video = $video.attr("src");
		// console.log(video);
		if (video.includes("?start=")) {
			$video.attr("src", `${video}&rel=0&mute=1&autoplay=1`);
		} else {
			$video.attr("src", `${video}?rel=0&mute=1&autoplay=1`);
		}
		ev.preventDefault();
	});
});

(function ($) {
	// Equalize on page load
	$(window).on('load', function () {
		equalizeBlocks();
		squareBlocks();
	});

	// Equalize on page resize
	$(window).resize(function () {
		equalizeBlocks();
		squareBlocks();
		equalizeTimeline();
	});
})(jQuery);


$(document).ready(function () {
	let $myDiv = $('.block-activities-nav');
	if ($myDiv.length) {
		if (($(window).width() > 990)) {
			$('html, body').animate({
				scrollTop: $('.block-activities__slider').offset().top - 500
			}, 'slow');
		}
	}

	$(".testimonial-item-frame").each(function() {
		var frame = $(this);
		var playButton = frame.find(".btn-play-testimonial");
		var thumbnail = frame.find(".video-poster");
		var videoContainer = frame.find(".video-testimonial-container");
		var videoIframe = videoContainer.find(".video-testimonial");
		videoContainer.hide();

		playButton.click(function() {
			thumbnail.hide();
			playButton.hide();
			videoContainer.show();
			videoIframe.show();
		});
	});
});

